export default __webpack_public_path__ + "static/logo-edcefdd0d1acc90b8f99e97218285f74.svg";